const { DEV_MODE } = require('app/config');

const selectors = DEV_MODE ? require('./config.dev') : require('./config.prod');

module.exports = selectors;